var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnorderedListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 15.836H3.33699V14.166H1.66699V15.836ZM5.83366 15.8327H18.3337V14.166H5.83366V15.8327ZM1.66699 10.836H3.33699V9.16602H1.66699V10.836ZM5.83366 10.8327H18.3337V9.16602H5.83366V10.8327ZM1.66699 5.83602H3.33699V4.16602H1.66699V5.83602ZM5.83366 5.83268H18.3337V4.16602H5.83366V5.83268Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnorderedListIcon);
export default __webpack_public_path__ + "static/media/UnorderedListIcon.98659971a1dcb4260cdfa93da30d8461.svg";
export { ForwardRef as ReactComponent };